import type { User, UserRole, UserStatus } from "@/lib/api";

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
	Active: "アクティブ",
	Invited: "招待済み",
	Inactive: "無効",
};

export const USER_ROLE_LABELS: Record<UserRole, string> = {
	SuperAdmin: "超管理者",
	Admin: "管理者",
	Member: "メンバー",
};

/** ステータスフィルタの選択肢の並び (利用中 → 未使用の順)。 */
export const USER_STATUS_ORDER: readonly UserStatus[] = ["Active", "Invited", "Inactive"];

/** ロールフィルタの選択肢の並び (権限の強い順)。 */
export const USER_ROLE_ORDER: readonly UserRole[] = ["SuperAdmin", "Admin", "Member"];

/** ユーザー一覧の絞り込み条件。null は「すべて」を意味する。 */
export interface UserFilter {
	status: UserStatus | null;
	role: UserRole | null;
	organizationId: string | null;
}

export const NO_USER_FILTER: UserFilter = { status: null, role: null, organizationId: null };

export function filterUsers(users: readonly User[], filter: UserFilter): User[] {
	return users.filter(
		(user) =>
			(filter.status === null || user.status === filter.status) &&
			(filter.role === null || user.role === filter.role) &&
			(filter.organizationId === null || user.organizationId === filter.organizationId),
	);
}

export interface UserOrganizationOption {
	id: string;
	name: string;
}

/**
 * 組織フィルタの選択肢。一覧に実際に現れる組織だけを名前順で返すので、
 * 選んでも 0 件にしかならない組織は出てこない。
 */
export function userOrganizationOptions(users: readonly User[]): UserOrganizationOption[] {
	const byId = new Map<string, string>();
	for (const user of users) byId.set(user.organizationId, user.organizationName);
	return [...byId]
		.map(([id, name]) => ({ id, name }))
		.sort((a, b) => a.name.localeCompare(b.name, "ja"));
}
